import { render } from "./Register.vue?vue&type=template&id=4c6174ce"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
script.render = render

export default script